import React from 'react'
import {useNavigate} from 'react-router'
import {Modal} from '@thryvlabs/maverick'

export const KP11LegacyContactsBlockModal = () => {
  const navigate = useNavigate()
  return (
    <Modal
      altBtn={<></>}
      openOnLoad
      variant="default"
      footer
      action
      btnAction={() => {
        navigate('/')
      }}
      btnActionText="Ok"
      hideX
      disableX
      disableBackdropClick
      btnType="primary"
    >
      <div style={{padding: '20px', textAlign: 'center'}}>
        <strong>
          A little blast from the past! This account contains Legacy Contacts.
        </strong>
        <br></br>
        <br></br>
        For proper handling, please reach out to Client Care at <br></br>
        <strong>{`844-339-7494 (option 1).`}</strong>
      </div>
    </Modal>
  )
}
